import { useEffect } from "react";

import { useConfigurationStore } from "@stores";

export const useRedirectToMainPortal = (): boolean => {
  const { domainSettings } = useConfigurationStore();
  const { is_sandbox: isSandbox, main_domain_url: mainDomainUrl } = domainSettings ?? {};
  const shouldRedirect = mainDomainUrl && isSandbox;

  useEffect(() => {
    if (shouldRedirect) {
      window.location.replace(mainDomainUrl);
    }
  }, [shouldRedirect, mainDomainUrl]);

  return Boolean(shouldRedirect);
};
